import React, { useState } from 'react';
import { BillsVService } from '../../../services/V2/gozer';
import { CircularProgress, Link } from '@material-ui/core';
import { authProvider } from '../../../services/Security';
import { CustomTable } from '../../shared/CustomTable';
import { dateToLocal, formatShortDate } from '../../shared/Functions';
import { Bill } from './Bill';

export const BillArchive = ({ successToast, errorToast }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(true);
    const [billingAccountId, setBillingAccountId] = useState<any>()
    const [token, setToken] = useState<any>()
    const [bill, setBill] = useState<any>();
    const [showBill, setShowBill] = useState<boolean>(false);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setBillingAccountId(data?.billingAccountId)
        setToken(data?.token)
    });

    const openBill = (rowData) => {
        setBill(rowData)
        setShowBill(true)
    }

    return (
        <>
            {showBill &&
                <Bill
                    show={showBill}
                    hide={() => setShowBill(false)}
                    billingAccountId={billingAccountId}
                    bill={bill}
                    fail={errorToast}
                />
            }
            {!billingAccountId || !token ? <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div> :
            <CustomTable
                columns={[
                    { title: 'Bill Date', field: '', render: rowData => dateToLocal(rowData.billingCycle.billDate).toLocaleDateString() || '-' },
                    { title: 'Month/Year', field: '', render: rowData => formatShortDate(rowData.billingCycle.cycleMonth - 1, rowData.billingCycle.cycleYear) || '-' },
                    { title: 'Bill Link', field: '', render: rowData => rowData.billStoredObjectId ? <Link className="clickable" onClick={() => openBill(rowData)}>View Bill</Link> : '' }
                ]}
                pageSize={15}
                enablePaging={false}
                actions={[]}
                hiddenColumns={[]}
                setHiddenColumns={[]}
                hiddenColumnsDisabled={true}
                refresh={refresh}
                setRefresh={setRefresh}
                dataEndpoint={(query) => {
                    return new Promise((resolve, reject) => {
                        BillsVService.billsVGetAll(billingAccountId, {
                            pageNumber: (query?.pageNumber ?? 1),
                            numberPerPage: 15,
                            orderBy: query?.orderBy?.field?.toString() ?? "CreatedAt",
                            orderByDesc: query?.orderDirection ? query.orderDirection === 'desc' : true,
                            filters: []
                        }).then(x => {
                            setLoading(false)
                            resolve(x)
                        }).catch(x => {
                            reject(x)
                        })
                    })
                }}
                dataSet={null}
                title={""}
                districtId={null}
                addedQuery={null}
                tableHeight={"550px"}
                enableSearch={false}
                searchPlaceholder={null} />
            }
            {loading &&
                <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
            }
        </>
    )
}